import Header from "./components/Header";
import Hero from "./components/Hero";
import HotZone from "./components/HotZone";
import Feed from "./components/Feed";
import DeepDive from "./components/DeepDive";
import BriefBar from "./components/BriefBar";
import PersonaZone from "./components/PersonaZone";
import ReportCta from "./components/ReportCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <HotZone />
        <Feed />
        <DeepDive />
        <BriefBar />
        <PersonaZone />
        <ReportCta />
      </main>
      <Footer />
    </div>
  );
}